import React from "react";
import { tncMocks } from "../mocks/tncMock";
import RichTextRenderer from "../components/common/richTextRerender";
import { selectTermsWhole } from "../redux/features/termsSlice";
import useLanguageTranslate from "../hooks/useLanguageTranslate";
import { useSelector } from "react-redux";

const TermsAndConditions = () => {
  const translate = useLanguageTranslate()
  // const tncData = tncMocks.data.content;
  const tncRedux = useSelector(selectTermsWhole)
  const tncData = tncRedux?.data?.data;
  return <div className="dynamic_page w-[1128px] max-w-[100%] mx-auto flex-col items-center gap-20 pt-[80px] pb-[100px] max767:p-5 ipad:px-12 ipad:py-12 laptop:px-12 laptop:py-16">
    <RichTextRenderer content={translate(tncData?.content, tncData?.content_ar)} />;
  </div>

};

export default TermsAndConditions;
